import React from 'react'
import { actualPolicies } from './actual-policies'
import './student-policies.css'
import { useParams } from 'react-router-dom'
import { InputWithInsetLabel } from '../DanitComponents/Inputs/InputWithInsetLabel'
import axios from 'axios'
import { baseUrl } from '../assets/Animations'
import { convertSchoolAbbreviationsToNames } from '../utilityFunctions'
import { GuitarPlayerSVG } from '../NewStudentForm/AutoFillNewStudentForm/ConfirmationPage/GuitarPlayerSVG'

const StudentPolicies = () => {
    const [policies, setPolicies] = React.useState(actualPolicies)
    const [signature, setSignature] = React.useState('')
    const [date, setDate] = React.useState('')
    const [family, setFamily] = React.useState({})
    const [school, setSchool] = React.useState('')
    const [submitted, setSubmitted] = React.useState(false)
    const [loading, setLoading] = React.useState('Loading Policies...')
    const [submitting, setSubmitting] = React.useState(false)

    const {familyId} = useParams()

    React.useEffect(() => {
        axios.get(`${baseUrl}/school-management-student-policies/${familyId}`)
        .then((res) => {
            setFamily(res.data)
        })
        .catch((err) => console.log(err))
    }, [])

    React.useEffect(() => {
        if(document.getElementById('Full Name')) {
            signature.length > 0 ? document.getElementById('Full Name').style.border = 'none' : document.getElementById('Full Name').style.border = '1px solid red'
        }
    }, [signature])

    React.useEffect(() => {
        if(document.getElementById('Date')) {
            date.length > 0 ? document.getElementById('Date').style.border = 'none' : document.getElementById('Date').style.border = '1px solid red'
        }
    }, [date])

    React.useEffect(() => {
        family.school ? setLoading(false) : setLoading('Loading Policies...')
        family.school && setSchool(convertSchoolAbbreviationsToNames(family.school.toLowerCase()))
    }, [family])


    const handleChange = (id, newValue) => {
        if(newValue.length > 1) {
            document.getElementById(`initial-${id}`).style.border = '1px solid #E2E8F0'
        }
        const updatedPolicies = policies.map(policy => 
            policy.id === id ? { ...policy, initialValue: newValue } : policy
        );
        setPolicies(updatedPolicies);
    };

    const submitPolicies = () => {
        if (verifyInitials() && checkSignatures()) {
            setSubmitting(true)
            let packet = {}
            packet.id = Math.random().toString(16).slice(2)
            packet.familyId = familyId
            packet.familyName = family.familyName
            packet.primaryEmail = family.primaryEmail
            packet.school = family.school
            packet.signature = signature
            packet.signatureDate = date
            packet.dateSubmitted = new Date()
            packet.completed = true
            packet.initials = policies.map(policy =>  policy)

            axios.post(`${baseUrl}/policies-signed`, packet)
            .then((res) => {
                //console.log(res)
                setSubmitted(true)
                setSubmitting(false)
            })
            .catch((err) => console.log(err))
        } else {
            highlightEmptyInitials()
            highlightEmptySignatures()
        }
    }

    const verifyInitials = () => {
        return policies.every(policy => policy.initialValue)
    }

    const getLogoImage = (school) => {
        if(school === 'tem') {
            return '/tempe-logo__light.png'
        } else if (school === 'den') {
            return '/denton-logo.png'
        } else if (school === 'tul') {
            return '/tulsa-logo__light.png'
        } else {
            return `/${family.school.toLowerCase()}logo.png`
        }
    }

    const getLogoStyles = (school) => {
        if(school.toLowerCase() === 'tem') {
            return {width: '300px', marginTop: '-90px'}
        } else if (school === 'den') {
            return {width: '200px', backgroundColor: '#0000001f'}
        } else if (school === 'tul') {
            return {width: '300px', marginTop: '-70px', marginLeft: '-50px'}
        } else {
            return {width: '160px'}
        }
    }

    const highlightEmptyInitials = () => {
        //highlight empty signatures
        signature.length < 2 ? document.getElementById('Full Name').style.border = '1px solid red' : document.getElementById('signature').style.border = '1px solid #E2E8F0'
        const updatedPolicies = policies.map(policy => {
            if (!policy.initialValue) {
                document.getElementById(`initial-${policy.id}`).style.border = '1px solid red'
                document.getElementById(`initial-${policy.id}`).placeholder = 'Please Initial'
                return { ...policy, initialValue: '' }
            } else {
                return policy
            }
        });
        setPolicies(updatedPolicies);
    }

    const checkSignatures = () => {
        return signature.length > 1 && date.length > 1
    }

    const highlightEmptySignatures = () => {
        signature.length < 2 ? document.getElementById('Full Name').style.border = '1px solid red' : document.getElementById('signature').style.border = '1px solid #E2E8F0'
        date.length < 2 ? document.getElementById('Date').style.border = '1px solid red' : document.getElementById('date').style.border = '1px solid #E2E8F0'
    }

    if (family.school) {
        return (
                <div className='student-policies__wrapper'>
                <div className='student-policies__header'>
                <img className='student-policies__header-logo' style={getLogoStyles(family.school.toLowerCase())}  src={getLogoImage(family.school.toLowerCase())} alt='logo' />
                <img className='student-policies__header-img' src='/about-img.jpg' alt='recital' />
            </div>
            {submitting ?
                <div className='student-policies__policies'>
                    <div className='student-policies__policies__header'>
                        <div className='student-policies__policies__submitting'>Submitting...</div>
                    </div>
                </div>
                :
                <>
                {!submitted ?
            <div className='student-policies__policies'>
                <div className='student-policies__policies__header'>
                    <div className='student-policies__policies__header-title'>Student Policies</div>
                    <div className='student-policies__policies__header-school'>{school}</div>
                    <div className='student-policies__policies__header-subtitle'>Please familiarize yourself with these policies, and initial next to each item to signify that you understand and agree. </div>
                </div>
                <div className='student-policies__policies__wrapper'>
                {policies.map(policy => (
                    <div className='student-policies__policies__each-policy' key={policy.id}>
                        <input id={`initial-${policy.id}`} className='student-policies__policies__each-policy__initial' placeholder='Initials' value={policy.initialValue} onChange={(e) => handleChange(policy.id, e.target.value)} />
                        <div className='student-policies__policies__each-policy__text-wrapper'>
                            <div className='student-policies__policies__each-policy__title'>{policy.title}</div>
                            <div className='student-policies__policies__each-policy__description'>{policy.description}</div>
                        </div>
                    </div>
                ))}
                </div>
                <div>
                    <div className='student-policies__bottom-signature-area__wrapper'>
                        <div className='student-policies__bottom-signature-input__wrapper'>
                            <InputWithInsetLabel label={'Full Name'} placeholder={'Enter your full name to sign'} value={signature} changeFunction={(e) => setSignature(e.target.value)} />
                        </div>
                        <div className='student-policies__bottom-signature-input__wrapper'>
                            <InputWithInsetLabel label={'Date'} placeholder={'Enter today\'s date'} value={date} changeFunction={(e) => setDate(e.target.value)} />
                        </div>
                    </div>
                    <div className='student-policies__bottom-signature-area__submit-btn__wrapper'>
                        <div className='student-policies__bottom-signature-area__submit-btn' onClick={() => submitPolicies()}>Submit</div>
                    </div>
                </div>
            </div>
        :
            <div className='student-policies__policies student-policies__completed'>
                <div className='student-policies__text'>Thank you for signing our policy form. You will receive a copy in your email shortly. </div>
                <GuitarPlayerSVG />
            </div>
        }
                </>
            }
        </div>
        )
    } else {
        return (
            <div className='student-policies__wrapper'>
                <div className='student-policies__loading'>{loading}</div>
            </div>
        )
    }
}
export default StudentPolicies